import { css } from '@emotion/css';

type CssPosition = 'left' | 'right';

const zIndex29 = css`
  z-index: 29;
`;
const topNavbarHeight = '8rem';
const rightSideBarHeight = css`
  height: calc(100vh - ${topNavbarHeight});
`;

const styles = {
  commonAdBox: 'md:content-box flex justify-center',
  sideAdTopContainer: (position: CssPosition) =>
    `${
      position === 'left' ? 'side-ad-box-left' : 'side-ad-box-right'
    } sticky top-28 h-full ${zIndex29} ${rightSideBarHeight}`,
  sideAdBottomContainer: (position: CssPosition) =>
    `sticky top-0 flex h-full w-full overflow-visible ${
      position === 'left' ? 'justify-end' : 'justify-start'
    }`,
};

export default styles;
